import React from 'react';
const privacy = require('./htmlPrivacyPolicy.html');

export default function PrivacyPolicy() {
    return <div dangerouslySetInnerHTML={{ __html: privacy.default }} style={{ padding: 60 }}></div>;
}
